export default {
  Menu: {
    parts: ['item', 'command', 'list', 'button', 'groupTitle', 'divider'],
    baseStyle: {},
    sizes: {},
    variants: {},
    defaultProps: {},
  },
};
